<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <!-- <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item> -->
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="资源名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
// import { getDataMap } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {

      },
      onlineStatusData: [],
    };
  },
  created() {
    // getDataMap("ONLINE_STATUS").then((res) => {
    //   if (!res || res.code != 0) return;
    //   res.data.splice(0, 0, {
    //     paramKey: "",
    //     paramValue: "全部",
    //   });
    //   this.onlineStatusData = res.data;
    // });
  },
  methods: {
    initData() {
      this.$emit("search", { ...this.filters});
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
